import modal from './modal.html';
import view  from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports, StaffReportsEmployeesService, toastr, $uibModal) => {
			$scope.moment       = moment;
			$scope.start        = $scope.parameters.start;
			$scope.end          = $scope.parameters.end;
			const financialYear = ReportsService.financialYear();

			if (!$scope.start) {
				$scope.start = financialYear.start;
			}

			if (!$scope.end) {
				$scope.end = financialYear.end;
			}

			$scope.status = STATUSES.UNLOADED;

			$scope.dataTable = DataTablesService.configure({
				id:                 $scope.reportId,
				title:              'Finished Office Staff Report',
				frozenColumns:      true,
				reorderableColumns: true,
			}, {
				frozenLeftColumns:  1,
				frozenRightColumns: 2,
				order:              [
					[
						4,
						'asc',
					],
					[
						3,
						'asc',
					],
				],
			});

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get({
					              start: $scope.start.format(),
					              end:   $scope.end.format(),
				              })
				              .then((data) => {
					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.openModal = (supportWorkerId) => {
				$uibModal.open({
					animation:                  true,
					template:                   modal,
					scope:                      $scope,
					size:                       'lg',
					controller: /* @ngInject */ ($scope, $uibModalInstance) => {
						$scope.modalSupportWorker = $scope.data.find((item) => {
							return item['Worker Id'] === supportWorkerId;
						});

						$scope.modalLeavingTypeOptions = [
							'Family/Health/Study Concerns',
							'Found FT Work or Change of Jobs',
							'Low Hours/Service Problems',
							'Moved Interstate',
							'Not Advised',
							'Terminated by AAC',
							'Unhappy with AAC',
							'Other',
						];

						$scope.modalData = {
							leavingType: $scope.modalSupportWorker['Leaving Type'],
						};

						$scope.modalCancel = () => {
							$uibModalInstance.close();
						};

						$scope.modalConfirm = () => {
							StaffReportsEmployeesService.updateOneSupportWorker(supportWorkerId, $scope.modalData)
							                            .then((response) => {
								                            toastr.clear();
								                            toastr.success('The support worker was successfully updated. To show the latest data, please click the Update button.', 'Success');

								                            $uibModalInstance.close();
							                            })
							                            .catch((error) => {
								                            toastr.clear();
								                            toastr.error('There was an error while updating the support worker, please try again.', 'Error');
							                            });
						};
					},
				});
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/6C4AB052-C473-4D07-832E-792615311A03/index.js